export const typedArrayToURL = (typedArray: string | undefined, mimeType: string): string => {
    return typedArray ? URL.createObjectURL(new Blob([typedArray], { type: mimeType })) : '';
};

export const blobToURL = (blob: Blob | null): string => {
    return blob ? URL.createObjectURL(blob) : '';
};
